import { Hour } from '../types';

export default function formatPeakHour(hour?: Hour) {
    return hour !== undefined ? `${hour}h - ${hour + 1}h` : 'No data';
}
